// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"vw_a bhf_b"};